import { render } from "./MyInput.vue?vue&type=template&id=4723e5ac&scoped=true"
import script from "./MyInput.vue?vue&type=script&lang=js"
export * from "./MyInput.vue?vue&type=script&lang=js"

import "./MyInput.vue?vue&type=style&index=0&id=4723e5ac&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-4723e5ac"

export default script